import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const Header = React.forwardRef(({ className, sticky = false, ...props }, ref) => {
    return (_jsx("header", { ref: ref, className: cn('bg-white border-b border-gray-200', sticky && 'sticky top-0 z-40', className), ...props }));
});
Header.displayName = 'Header';
export { Header };
